import { getLoginToken } from '../local-storage/login-token'
import { Configuration } from '../types/typescript-axios'

export function apiConfiguration(): Configuration {
  const token = getLoginToken()
  const apiKey = token?.token
  return new Configuration({ basePath: '/api', ...(apiKey && { apiKey }) })
}
